import { createRef, RefObject, useCallback, useMemo } from 'react';

export const useSetCenterScroll = (list: { key: string; value: string }[]) => {
  const refs = useMemo(
    () =>
      list.reduce<Record<string, RefObject<HTMLLIElement | null>>>((acc, { key }) => {
        acc[key] = createRef<HTMLLIElement>();
        return acc;
      }, {}),
    [list],
  );

  const setScrollCenter = useCallback(
    (selectedKey: string) => {
      refs[selectedKey]?.current?.scrollIntoView({
        block: 'center',
      });
    },
    [refs],
  );

  return {
    itemRefs: refs,
    setScrollCenter,
  };
};
